module.exports = __webpack_public_path__ + "img/icon-menu-dots-grey.e511abae.svg";